import Breadcrumb from "../components/Breadcrumb";
import ClientPermissions from "../components/ClientPermissions";

const ClientPermissionsPage = () => {
  return (
    <>
      {/* Breadcrumb */}
      <Breadcrumb title="Permissions" />

      <ClientPermissions />
    </>
  );
};

export default ClientPermissionsPage;
